// ==============================================
// Global fetch interceptor
// ==============================================
// Installed once at startup. Every request to our backend automatically gets the
// stored bearer token attached, and a 401 (expired/invalid token) clears the
// session and redirects to /login. Until a token exists this is a no-op, so the
// current tokenless backend behaves exactly as before — but the app is fully
// JWT-ready the moment a token-issuing backend is wired in.

import { getToken, clearSession } from './auth';
import { API_HOST } from '../config';

export function installAuthInterceptor() {
  if (typeof window === 'undefined' || window.__authInterceptorInstalled) return;
  window.__authInterceptorInstalled = true;

  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const isApi = API_HOST && url.includes(API_HOST);
    if (!isApi) return originalFetch(input, init);

    const token = getToken();
    const headers = new Headers(
      init.headers || (typeof input !== 'string' && input ? input.headers : undefined) || {}
    );
    // Never overwrite Content-Type — FormData uploads must keep their boundary.
    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    const response = await originalFetch(input, { ...init, headers });

    // Only react to 401 when we actually sent a token and it wasn't an auth call,
    // so login errors and the current tokenless backend are never disrupted.
    if (response.status === 401 && token && !url.includes('/auth/')) {
      clearSession();
      if (!window.location.pathname.startsWith('/login')) {
        window.location.replace('/login');
      }
    }
    return response;
  };
}
